import { createScale } from '../internal';
export const respirationRateBounds = [{
  lower: 0,
  upper: 8,
  score: {
    type: 'low',
    value: 3
  }
}, {
  lower: 9,
  upper: 11,
  score: {
    type: 'low',
    value: 1
  }
}, {
  lower: 12,
  upper: 20,
  score: {
    type: 'normal',
    value: 0
  }
}, {
  lower: 21,
  upper: 24,
  score: {
    type: 'high',
    value: 2
  }
}, {
  lower: 25,
  upper: Infinity,
  score: {
    type: 'high',
    value: 3
  }
}];
/**
 * Respiration Rate (/min) `integer/min`
 */

export const respirationRate = createScale(respirationRateBounds, 0);
//# sourceMappingURL=respiration-rate.js.map